import { render, staticRenderFns } from "./LmBox.vue?vue&type=template&id=6f886f8c&scoped=true&"
import script from "./LmBox.vue?vue&type=script&lang=js&"
export * from "./LmBox.vue?vue&type=script&lang=js&"
import style0 from "./LmBox.vue?vue&type=style&index=0&id=6f886f8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f886f8c",
  null
  
)

export default component.exports